<template>
  <div class="d-flex justify-content-between align-items-center border border-primary rounded-pill py-1 my-4">
    <button class="btn btn-sm border-0" :disabled="chapter === 1" @click="goToPreviousPage">
      <i class="fa-solid fa-angles-left"></i>
    </button>
    <h2 class="fs-4">{{ book.name }} - <small>{{ chapter }}</small></h2>
    <button class="btn btn-sm border-0" :disabled="chapter === book.chapters.length" @click="goToNextPage">
      <i class="fa-solid fa-angles-right"></i>
    </button>
  </div>
  <ul class="list-group">
    <li class="list-group-item" v-for="(verse, index) in verses" :key="index">
      <strong class="fst-italic">{{ index + 1 }}</strong> . {{ verse }}
    </li>
  </ul>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  book: Object,
  chapter: Number,
  verses: Array
});

const emit = defineEmits(['changeChapter']);

const emitChangeChapter = (direction) => {
  emit('changeChapter', direction);
};

const goToPreviousPage = () => emitChangeChapter('prev');
const goToNextPage = () => emitChangeChapter('next');
</script>

<style scoped>
.verses-display {
  margin-top: 20px;
}

.verses-display ul {
  list-style-type: none;
}

.verses-display button {
  margin: 5px;
}
</style>
